import { useParams, useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { usePeriodStore } from '@/stores/periodStore'
import { WizardLayout } from '@/components/wage-wizard/WizardLayout'
import { WizardUploadContent } from '@/components/wage-wizard/upload/WizardUploadContent'

export function WizardUploadStep() {
  const { periodId } = useParams<{ periodId: string }>()
  const navigate = useNavigate()
  const { currentUser } = useAuth()
  const markStepComplete = usePeriodStore(state => state.markStepComplete)

  const handleComplete = async () => {
    if (currentUser && periodId) {
      await markStepComplete(currentUser, periodId, 'upload')
    }
    navigate(`/periods/${periodId}/adjustments`)
  }

  if (!periodId) {
    return null
  }

  return (
    <WizardLayout currentStep="upload">
      <WizardUploadContent
        periodId={periodId}
        onComplete={handleComplete}
      />
    </WizardLayout>
  )
}
